import { Box } from "@mui/material";
import { useAppSelector } from "src/redux/hooks/redux";
import { findBlockedNumber } from "./blockNumber.action";
import { useBlockedNumbersQuery } from "./useBlockedNumbersQuery";

interface Props {
  phoneNumber?: string | null;
}

export function BlockedNumberChip({ phoneNumber }: Props) {
  const companyId = useAppSelector((state) => state.userState.company?.id);
  const { data: blockedNumbers = [] } = useBlockedNumbersQuery(companyId);
  const blocked = findBlockedNumber(blockedNumbers, phoneNumber);

  if (!blocked) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        px: 0.8,
        py: 0.25,
        borderRadius: "4px",
        fontSize: "10px",
        fontWeight: 700,
        bgcolor: "rgba(211, 47, 47, 0.12)",
        color: "#d32f2f",
        textTransform: "uppercase",
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      Blocked
    </Box>
  );
}
